import React from "react";
import {
  Typography,
  Box,
  Divider,
  Modal,
  Button,
  Container,
} from "@mui/material";

interface TermsAndConditionsModalProps {
  open: boolean;
  onClose: () => void;
}

export const TermsAndConditionsModal: React.FC<TermsAndConditionsModalProps> = ({open, onClose}) => {


  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
      >
        <Container
        maxWidth="md"
        sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            mt: 8,
            borderRadius: 2,
            maxHeight: "80vh",
            overflowY: "auto",
        zIndex: 1301, // Set z-index higher than Backdrop (Backdrop default is 1300)

        }}
        >
        <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography variant="h4" gutterBottom>
            Terms and Conditions
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
            Please read these terms and conditions carefully before using our platform.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            1. Introduction
            </Typography>
            <Typography variant="body1">
            Welcome to ShareStock ("the Platform"), a web-based platform designed to connect
            retail stores ("Users") with each other to enable buying and selling of goods and services.
            By accessing or using the Platform, you agree to comply with and be bound by these Terms and
            Conditions ("Terms"). If you do not agree with these Terms, you may not use the Platform.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            2. Eligibility
            </Typography>
            <Typography variant="body1">
            To use the Platform, you must:
            </Typography>
            <ul>
            <li>Be at least 18 years old.</li>
            <li>Have the authority to enter into binding agreements on behalf of your retail store.</li>
            <li>Comply with all applicable laws and regulations.</li>
            </ul>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            3. Account Registration
            </Typography>
            <Typography variant="body1">
            Each User must create an account to access the Platform.
            </Typography>
            <ul>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>All information provided during registration must be accurate, complete, and up-to-date.</li>
            </ul>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            4. Use of the Platform
            </Typography>
            <Typography variant="body1">
            Users may:
            </Typography>
            <ul>
            <li>List products or services for sale.</li>
            <li>Browse and purchase products or services from other Users.</li>
            <li>Communicate with other Users for business purposes.</li>
            </ul>
            <Typography variant="body1">
            Users must not:
            </Typography>
            <ul>
            <li>Use the Platform for any illegal or unauthorized purposes.</li>
            <li>Misrepresent products or services.</li>
            <li>Interfere with the operation of the Platform.</li>
            </ul>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            5. Fees and Payments
            </Typography>
            <ul>
            <li>The Platform may charge fees for certain features or transactions. These fees will be clearly disclosed.</li>
            <li>Users are responsible for any taxes or fees associated with their transactions.</li>
            <li>Payments between Users are facilitated through third-party payment processors, and the Platform is not responsible for payment disputes.</li>
            </ul>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            6. User Responsibilities
            </Typography>
            <ul>
            <li>Users are responsible for ensuring the accuracy of their listings and compliance with applicable laws.</li>
            <li>Users must resolve disputes with other Users directly. The Platform is not liable for any disputes arising from transactions.</li>
            </ul>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            7. Intellectual Property
            </Typography>
            <Typography variant="body1">
            The Platform and its content are protected by intellectual property laws.
            </Typography>
            <Typography variant="body1">
            Users retain ownership of the content they upload but grant the Platform a license to display and distribute such content as necessary to operate the Platform.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            8. Privacy
            </Typography>
            <Typography variant="body1">
            The Platform collects and uses personal data in accordance with its Privacy Policy, which forms part of these Terms.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            9. Termination
            </Typography>
            <Typography variant="body1">
            The Platform may suspend or terminate your account if you violate these Terms or engage in conduct that harms the Platform or its Users.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            10. Limitation of Liability
            </Typography>
            <Typography variant="body1">
            The Platform is provided "as is" and "as available."
            </Typography>
            <Typography variant="body1">
            The Platform is not liable for any direct, indirect, incidental, or consequential damages arising from your use of the Platform.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            11. Indemnification
            </Typography>
            <Typography variant="body1">
            You agree to indemnify and hold the Platform, its affiliates, and its representatives harmless from any claims, damages, or expenses arising from your use of the Platform.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            12. Modifications
            </Typography>
            <Typography variant="body1">
            The Platform reserves the right to modify these Terms at any time. Changes will be communicated, and continued use of the Platform constitutes acceptance of the revised Terms.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            13. Governing Law
            </Typography>
            <Typography variant="body1">
            These Terms are governed by the laws of Montana. Any disputes will be resolved in the courts of Montana.
            </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
            14. Contact Information
            </Typography>
            <Typography variant="body1">
            For questions or concerns about these Terms, contact us at sharestockwithme@gmail.com .
            </Typography>
        </Box>

        <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button variant="contained" color="secondary" onClick={onClose}>
            Close
            </Button>
        </Box>
        </Container>
      </Modal>
    </div>
  );
};

export default TermsAndConditionsModal;
